import { render, staticRenderFns } from "./CommentButtons.vue?vue&type=template&id=75a8500a&"
import script from "./CommentButtons.vue?vue&type=script&lang=js&"
export * from "./CommentButtons.vue?vue&type=script&lang=js&"
import style0 from "./CommentButtons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports